import { render, staticRenderFns } from "./LvFinal.vue?vue&type=template&id=31f86b6e"
import script from "./LvFinal.vue?vue&type=script&lang=js"
export * from "./LvFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports